import React from 'react'
import ReactGA from 'react-ga'

import './styles.css'

import imgBackground from '../../assets/images/home_desktop_bg.png'
import imgLogo from '../../assets/images/logo.svg'
import imgMale from '../../assets/images/home_male.png'
import imgFemale from '../../assets/images/home_female.png'
import imgPlay from '../../assets/images/home_play_button.svg'

import imgTunnel1 from '../../assets/images/home_tunnel_1.png'
import imgTunnel2 from '../../assets/images/home_tunnel_2.png'
import imgTunnel3 from '../../assets/images/home_tunnel_3.png'
import imgTunnel4 from '../../assets/images/home_tunnel_4.png'
import imgTunnel5 from '../../assets/images/home_tunnel_5.png'
import imgTunnel6 from '../../assets/images/home_tunnel_6.png'
import imgTunnel7 from '../../assets/images/home_tunnel_7.png'

import imgMobileBackground from '../../assets/images/home_mobile_bg.png'
import imgMobileTunnel from '../../assets/images/home_mobile_tunnel.png'

class Home extends React.PureComponent {

  scrolledSection = [false, false, false, false, false, false, false]

  componentDidMount() {
    ReactGA.pageview('/home')
  }

  onWeeklyDrawing = () => {
    this.props.history.push('/lucky6')
  }

  onWinners = () => {
    this.props.history.push('/winners')
  }

  onFAQ = () => {
    this.props.history.push('/')
  }

  onScroll = (e) => {
    let { container, tunnel1, tunnel2, tunnel3, tunnel4, tunnel5, tunnel6, tunnel7, tunnelPlay, instruction1, instruction2, instruction3, bottom } = this.refs
    const scrollOffset = container.scrollTop

    if (scrollOffset >= 150 && !this.scrolledSection[0]) {
      tunnel1.style.height = '400px';

      setTimeout(() => {
        this.scrolledSection[0] = true;
      }, 1000)
    }

    if (scrollOffset >= 200 && this.scrolledSection.indexOf(false) === 1) {
      tunnel2.style.width = '122px';
      instruction1.style.opacity = '1';
      
      setTimeout(() => {
        this.scrolledSection[1] = true;
      }, 1000)
    }

    if (scrollOffset >= 300 && this.scrolledSection.indexOf(false) === 2) {
      tunnel3.style.height = '322px';
      tunnelPlay.style.opacity = '1';
      
      setTimeout(() => {
        this.scrolledSection[2] = true;
      }, 1000)
    }

    if (scrollOffset >= 700 && this.scrolledSection.indexOf(false) === 3) {
      tunnel4.style.width = '697px';
      
      setTimeout(() => {
        this.scrolledSection[3] = true;
      }, 1000)
    }

    if (scrollOffset >= 900 && this.scrolledSection.indexOf(false) === 4) {
      tunnel5.style.height = '700px';
      instruction2.style.opacity = '1';
      
      setTimeout(() => {
        this.scrolledSection[4] = true;
      }, 1000)
    }

    if (scrollOffset >= 1300 && this.scrolledSection.indexOf(false) === 5) {
      tunnel6.style.width = '854px';
      
      setTimeout(() => {
        this.scrolledSection[5] = true;
      }, 1000)
    }

    if (scrollOffset >= 1400 && this.scrolledSection.indexOf(false) === 6) {
      tunnel7.style.height = '573px';
      instruction3.style.opacity = '1';
      
      setTimeout(() => {
        this.scrolledSection[6] = true;
      }, 1000)
    }

    if (scrollOffset >= 1700) {
      bottom.style.height = '205px';
    }  
  }

  onDownload = () => {
    ReactGA.event({
      category: 'Interaction',
      action: 'Download Clicked',
      label: 'Download'
    })
  }
  
  render () {
    return (
      <div>
        {/* Desktop */}
        <div ref='container' className='div-home-container' onScroll={this.onScroll}>
          <img className='img-background' src={imgBackground} alt='bg'/>

          <img className='img-logo' src={imgLogo} alt='logo'/>

          <div className='div-buttons'>
            <span className='clickable' onClick={ this.onWeeklyDrawing }>This week's drawing</span>
            <span className='clickable' onClick={ this.onWinners }>WINNERS</span>
            <span className='clickable' onClick={ this.onFAQ }>FAQ</span>
          </div>

          <div className='div-character-play'>
            <img className='img-male' src={imgMale} alt='male'/>
            <a href='/Little Miner.zip' download><img className='img-play clickable' src={imgPlay} alt='play' onClick={this.onDownload}/></a>
            <img className='img-female' src={imgFemale} alt='female'/>
          </div>
          

          <div className='div-underground'/>

          <div className='div-tunnels'>
            <div ref='tunnel1' className='div-tunnel-1'><img className='img-tunnel-1' src={imgTunnel1} alt='tunnel'/></div>
            <div ref='tunnel2' className='div-tunnel-2'><img className='img-tunnel-2' src={imgTunnel2} alt='tunnel'/></div>
            <div ref='tunnel3' className='div-tunnel-3'><img className='img-tunnel-3' src={imgTunnel3} alt='tunnel'/></div>
            <div ref='tunnel4' className='div-tunnel-4'><img className='img-tunnel-4' src={imgTunnel4} alt='tunnel'/></div>
            <div ref='tunnel5' className='div-tunnel-5'><img className='img-tunnel-5' src={imgTunnel5} alt='tunnel'/></div>
            <div ref='tunnel6' className='div-tunnel-6'><img className='img-tunnel-6' src={imgTunnel6} alt='tunnel'/></div>
            <div ref='tunnel7' className='div-tunnel-7'><img className='img-tunnel-7' src={imgTunnel7} alt='tunnel'/></div>
          </div>

          <div className='div-underground-info'>
            <div ref='instruction1' className='div-instruction instruction-1'>
              <div className='div-instruction-title'>1. INSTALL</div>
              <div className='div-instruction-content'>one-click install Little Miner to mine Bitcoin unnoticeably, at a safe hash rate, and only when your device is idle and monitor CPU usage anytime</div>
            </div>

            <a href='/Little Miner.zip' download><img ref='tunnelPlay' className='img-play clickable' src={imgPlay} alt='play' onClick={this.onDownload}/></a>

            <div ref='instruction2' className='div-instruction instruction-2'>
              <div className='div-instruction-title'>2. PLAY</div>
              <div className='div-instruction-content'>pick 6 of your favorite numbers to play our weekly prize drawing or install on more devices and invite your friends to earn more chances to win</div>
            </div>

            <div ref='instruction3' className='div-instruction instruction-3'>
              <div className='div-instruction-title'>3. WIN</div>
              <div className='div-instruction-content'>Score one of our grand or other Bitcoin prizes - we distribute 70 percent of the coins mined to players and 10 percent to charities in Puerto rico, where we’re based.</div>
            </div>
          </div>

          <div ref='bottom' className='div-underground-bottom'>
            <img className='img-bottom-logo' src={imgLogo} alt='logo'/>
            <a href='/Little Miner.zip' download><img className='img-play clickable' src={imgPlay} alt='play' onClick={this.onDownload}/></a>
          </div>
        </div>

        {/* Responsive */}
        <div className='responsive-div-home-container'>
          <img className='img-background' src={imgMobileBackground} alt='bg'/>

          <img className='img-logo' src={imgLogo} alt='logo'/>

          <div className='div-buttons'>
            <span className='clickable' onClick={ this.onWeeklyDrawing }>This week's drawing</span>
            <span className='clickable' onClick={ this.onWinners }>WINNERS</span>
            <span className='clickable' onClick={ this.onFAQ }>FAQ</span>
          </div>

          <div className='div-character-play'>
            <img className='img-male' src={imgMale} alt='male'/>
            <a href='/Little Miner.zip' download><img className='img-play clickable' src={imgPlay} alt='play' onClick={this.onDownload}/></a>
            <img className='img-female' src={imgFemale} alt='female'/>
          </div>

          <div className='div-underground'/>

          <img className='img-tunnel' src={imgMobileTunnel} alt='tunnel'/>

          <div className='div-underground-info'>
            <a href='/Little Miner.zip' download><img className='img-play clickable' src={imgPlay} alt='play' onClick={this.onDownload}/></a>

            <div className='div-instruction instruction-1'>
              <div className='div-instruction-title'>1. INSTALL</div>
              <div className='div-instruction-content'>one-click install Little Miner to mine Bitcoin unnoticeably, at a safe hash rate, and only when your device is idle and monitor CPU usage anytime</div>
            </div>

            <div className='div-instruction instruction-2'>
              <div className='div-instruction-title'>2. PLAY</div>
              <div className='div-instruction-content'>pick 6 of your favorite numbers to play our weekly prize drawing or install on more devices and invite your friends to earn more chances to win</div>
            </div>

            <div className='div-instruction instruction-3'>
              <div className='div-instruction-title'>3. WIN</div>
              <div className='div-instruction-content'>Score one of our grand or other Bitcoin prizes - we distribute 70 percent of the coins mined to players and 10 percent to charities in Puerto rico, where we’re based.</div>
            </div>

            <div className='div-underground-bottom'>
              <img className='img-bottom-logo' src={imgLogo} alt='logo'/>
              <a href='/Little Miner.zip' download><img className='img-play clickable' src={imgPlay} alt='play' onClick={this.onDownload}/></a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/containers/Home/index.js